import axios from "axios";

const baseActivationsPath = `/activations`;

// #region common DTOs
export enum AppInCloudRoles {
    CompanyAdmin = 'CompanyAdmin',
    Operator = 'Operator'
}

export type DerivedActivationStatus = 'Active' | 'Warning' | 'Blocked';

export interface ActivationDTO {
    activationOid: string;
    companyOid: string;
    companyName: string;
    companyVatCode: string;
    companyFiscalCode: string;
    companyClientCode: string;
    activeLicense: string;
    serverDomain: string;
    serverOid: string;
    serverUri: string;
    roleName: AppInCloudRoles;
    status: DerivedActivationStatus | string;
    cardMessage: string | null;
}
//#endregion

// #region GET activations
interface GetActivationsResponse {
    userOid: string;
    activations: ActivationDTO[]
}
//#endregion

// #region GET activation
interface GetActivationRequest {
    params: {
        id: string;
    }
}
interface GetActivationResponse {
    id: string
    url: string
    serverOid: string
    serverUri: string
    serverDomain: string
    licenseOid: string
    licenseSlots: number
    companyUsers: number
    roleOid: string
    roleName: string
}
//#endregion

// #region GET remote access link
interface RemoteAccessRequest {
    params: {
        id: string;
    }
}
//#endregion

export function GetActivations() {
    return axios.get<GetActivationsResponse>(`${baseActivationsPath}`)
}

export function GetActivation(request: GetActivationRequest) {
    return axios.get<GetActivationResponse>(`${baseActivationsPath}/${request.params.id}`)
}

export function RemoteAccess(request: RemoteAccessRequest) {
    return axios.get<string>(`${baseActivationsPath}/${request.params.id}/remoteaccess`)
}
